import { render } from "./RemoveComas.vue?vue&type=template&id=8b3016a8"
import script from "./RemoveComas.vue?vue&type=script&lang=js"
export * from "./RemoveComas.vue?vue&type=script&lang=js"

import "./RemoveComas.vue?vue&type=style&index=0&id=8b3016a8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__